import { create } from "zustand";

export type BackupAsk = { kind: "delete" };
export type BackupChoice = "confirm" | "cancel";

interface State {
  open: boolean;
  pending: BackupAsk | null;
  resolveFn: ((choice: BackupChoice) => void) | null;
  ask: (pending: BackupAsk) => Promise<BackupChoice>;
  resolve: (choice: BackupChoice) => void;
}

export const useBackupConfirmStore = create<State>((set, get) => ({
  open: false,
  pending: null,
  resolveFn: null,
  ask: (pending) =>
    new Promise((resolve) => {
      set({ open: true, pending, resolveFn: resolve });
    }),
  resolve: (choice) => {
    const fn = get().resolveFn;
    set({ open: false, pending: null, resolveFn: null });
    fn?.(choice);
  },
}));
